export const RESOURCE_TYPE = 'RESOURCE_TYPE_FETCH_USER_TRAITS';
export const RESOURCE_KEY = 'fetch-user-traits-resource-key';
export const ANALYTICS_ID = 'useResource.fetchUserTraits';
